import {create} from 'zustand';
import {SelectedBookingDateStore} from './types';

const useSelectedBookingDateStore = create<SelectedBookingDateStore>(set => ({
	selectedBookingDate: '',
	setSelectedBookingDate: value => set({selectedBookingDate: value}),
	resetSelectedBookingDate: () => set({selectedBookingDate: ''}),
}));

export {useSelectedBookingDateStore};
